export enum InitShutdownScriptType {
  Command = 'COMMAND',
  Script = 'SCRIPT',
}
